/* import __COLOCATED_TEMPLATE__ from './used-by-cell.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import Component from '@glimmer/component';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';

const ICON_MAP: Record<string, InterfaceIconName> = {
  Workflow: 'workflows',
  Procedure: 'fin',
  Task: 'custom-attribute',
  'Custom Answer': 'chat-bubble',
  'Fin Profile': 'bot-filled',
  'Inbox Workflow': 'workflows',
  Macro: 'saved-reply',
};

interface DependentObject {
  title: string;
  type: string;
  route: string;
}

interface GroupedDependentObjects {
  type: string;
  icon: InterfaceIconName | undefined;
  items: DependentObject[];
}

interface Signature {
  Args: {
    action: {
      dependentObjects: DependentObject[];
    };
  };
}

export default class UsedByCell extends Component<Signature> {
  get dependentObjects(): DependentObject[] {
    return this.args.action.dependentObjects ?? [];
  }

  get groupedDependentObjects(): GroupedDependentObjects[] {
    let groups = new Map<string, DependentObject[]>();

    for (let obj of this.dependentObjects) {
      if (!groups.has(obj.type)) {
        groups.set(obj.type, []);
      }
      groups.get(obj.type)!.push(obj);
    }

    return Array.from(groups.entries()).map(([type, items]) => ({
      type,
      icon: ICON_MAP[type],
      items,
    }));
  }

  get hasDependentObjects(): boolean {
    return this.dependentObjects.length > 0;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'WorkflowConnector::UsedByCell': typeof UsedByCell;
    'workflow-connector/used-by-cell': typeof UsedByCell;
  }
}
